import {
    CLOSED_RO,
    REOPEN_RO,
  } from "./ApiRoutes";
  import { authData } from "./services";
  
  export const listofCloseRO = async () => {
    const response = await authData.get(CLOSED_RO);
    return response?.data;
  };

  export const reopenRO = async (data: object) => {
    const response = await authData.put(REOPEN_RO,data);
    return response?.data;
  };